(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shock-tower-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const popup = document.querySelector('[data-pbrc-shock-popup]');
    if (!popup) return;

    const storageKey = 'pbrc-shock-tower-popup-closed';

    if (window.location.pathname === '/' || window.location.pathname === '') {
      try {
        window.sessionStorage.setItem(storageKey, 'true');
      } catch (error) {}
      popup.remove();
      return;
    }

    const wasClosed = () => {
      try {
        return window.sessionStorage.getItem(storageKey) === 'true';
      } catch (error) {
        return false;
      }
    };

    const markClosed = () => {
      try {
        window.sessionStorage.setItem(storageKey, 'true');
      } catch (error) {}
    };

    const closePopup = () => {
      popup.classList.add('is-closing');
      popup.hidden = true;
      markClosed();
    };

    if (!wasClosed()) {
      window.setTimeout(() => {
        popup.hidden = false;
      }, 700);
    }

    popup.querySelectorAll('[data-pbrc-shock-popup-close]').forEach((control) => {
      control.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !popup.hidden) {
        closePopup();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
